import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { BuyerDadosPedidoService } from '../dados-pedido/dados-pedido.service';
import { GeneralService } from 'app/_services/general.service';
import { NotificationService } from 'app/_services/notification.service';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { Globals } from 'app/_models/globals';
import { AddComplementDataModel } from './_models/addComplementDataModel';
import { AccountService } from 'app/account/account.service';

declare const isEmpty: any;
declare const setDateNextWorkingDay: any;

@Component({
    selector: 'dados-pedido-adicionar-complemento', templateUrl: './adicionar-complemento.component.html', styleUrls: ['./adicionar-complemento.component.scss'],
    standalone: false
})
export class BuyerPedidoAdicionarComplementoComponent implements OnInit {
    @Input() cotacaoSelecionada: AddComplementDataModel;
    @Input() deliveryTimes: any[];
    @Input() feriados: string[];
    @Input() visivel: boolean;
    @Output() fechar = new EventEmitter<any>();

    @ViewChild('template') template: TemplateRef<any>;
    modalRef: BsModalRef;

    calendarMaxDate: any;
    calendarMinDate: any;
    calendarMarkDisabled: any;
    private max_days_delivery: number = 40;

    loading: boolean;
    peca: any;

    userERP?: string = null;
    alreadyLoadedERP: boolean = false;

    constructor(private dadosPedidoService: BuyerDadosPedidoService, private notificationService: NotificationService, private globals: Globals, protected modalService: BsModalService, private calendar: NgbCalendar,
                private accountService: AccountService,
                private generalService: GeneralService,
                private ngxLoader: NgxUiLoaderService) { }

    ngOnInit(): void {
        this.loading = false;
        this.visivel = false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!isEmpty(changes.visivel)) {
            if (changes.visivel.currentValue) {
                this.peca = { codigo: '', descricao: '', quantidade: 1, data_entrega: '', valor_unitario: '', desconto: '', valor_total: 0, part_type: '1', brand: '', allows_used: false };
                this.montarCalendario();

                this.getUserERPName();

                let options: ModalOptions = { backdrop: 'static', class: 'gray modal-lg', keyboard: false };
                this.modalRef = this.modalService.show(this.template, options);
            }
            else if (this.modalRef)
                this.modalRef.hide();
        }
    }

    async adicionar(nAttempts: number) {
        if (this.userERP != null && !(await this.notificationService.showConfirmationDialog(this.globals.translate('buyer.dados-pedido.mensagens.adicionar-complemento.erro.erp-warning').replace('{{erp}}', `${this.userERP}`), null, false))) {
            return;
        }

        let sucesso = true;
        let errorMessage = '';
        let confirmationDate = this.cotacaoSelecionada.confirmation_date;
        let deliveryDate = null;

        if (!isEmpty(this.peca.data_entrega)) {
            // Se a data de confirmação for após as 18h, coloca na manhã do próximo dia útil
            if (confirmationDate.getHours() > 18)
                confirmationDate = setDateNextWorkingDay(confirmationDate, this.feriados);

            let hours = confirmationDate.getHours();
            let minutes = confirmationDate.getMinutes();
            let seconds = confirmationDate.getSeconds();

            deliveryDate = new Date(this.peca.data_entrega.year, this.peca.data_entrega.month - 1, this.peca.data_entrega.day, hours, minutes, seconds);
        }

        // Realiza a validação
        if (isEmpty(this.peca.descricao.trim())) {
            sucesso = false;
            errorMessage = 'description';
        }
        else if (this.peca.quantidade <= 0 || this.peca.quantidade > 999) {
            sucesso = false;
            errorMessage = 'quantity';
        }
        else if (this.peca.valor_unitario <= 0) {
            sucesso = false;
            errorMessage = 'price';
        }
        else if (this.peca.desconto < 0) {
            sucesso = false;
            errorMessage = 'discount';
        }
        else if (isEmpty(this.peca.data_entrega)) {
            sucesso = false;
            errorMessage = 'deliveryDate';
        }

        if (!sucesso) {
            await this.notificationService.showWarning('buyer.dados-pedido.mensagens.adicionar-complemento.erro.dados-invalidos.corpo.' + errorMessage, 'buyer.cotacao.mensagens.adicionar-complemento.erro.dados-invalidos.titulo');
            return;
        }

        let new_part = {
            part_number: isEmpty(this.peca.codigo) ? '' : this.peca.codigo.trim(),
            name: isEmpty(this.peca.descricao) ? '' : this.peca.descricao.trim(),
            quantity: (isEmpty(this.peca.quantidade) || this.peca.quantidade <= 0) ? 1 : this.peca.quantidade,
            price: this.peca.valor_unitario,
            discount: isEmpty(this.peca.desconto) ? 0 : this.peca.desconto,
            delivery_date: deliveryDate,
            part_type: parseInt(this.peca.part_type),
            brand: isEmpty(this.peca.brand) || this.peca.part_type <= 1 ? '' : this.peca.brand.trim(),
            selected_payment_type: this.cotacaoSelecionada.selected_payment_type,
            original_selected_payment_type: this.cotacaoSelecionada.original_selected_payment_type,
            chosen_date: this.cotacaoSelecionada.chosen_date,
            confirmation_date: this.cotacaoSelecionada.confirmation_date,
            allows_used: this.peca.allows_used
        };

        this.loading = true;

        this.dadosPedidoService.addOrderComplement(this.cotacaoSelecionada.order_id, this.cotacaoSelecionada.answer_in_id, new_part).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                if (response && response.success && response.result) {
                    this.loading = false;
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.dados-pedido.mensagens.adicionar-complemento.sucesso.salvar.corpo'));
                    this.fecharModal(true);
                }
                else
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.adicionar-complemento.erro.salvar.corpo'));
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.loading = false;
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.adicionar-complemento.erro.salvar.corpo'));
                    this.fecharModal(false);
                    return;
                }

                this.adicionar(++nAttempts);
            }
        });
    }

    fecharModal(atualizar) {
        this.fechar.emit({ atualizar: atualizar, transaction_id: this.cotacaoSelecionada.transaction_id });
    }

    getUserERPName() {
        this.alreadyLoadedERP = false;

        this.accountService.getUserERPName(this.cotacaoSelecionada.buyer_company_id).subscribe({
            next: (response: ApiResponseModel<string | null>) => {
                this.userERP = response.result;
                this.alreadyLoadedERP = true;
            },
            error: error => {
                console.log(error);
                this.alreadyLoadedERP = true;
            }
        });
    }

    onInputQuantityChange(event: any, peca: any): void {
        const inputValue = event.target.value;
        const maxDigits = event.target.maxLength;

        if (inputValue.length > maxDigits) {
            event.target.value = inputValue.slice(0, maxDigits);
            peca.quantidade = parseInt(event.target.value, 10) || 0;
        }
    }

    private montarCalendario() {
        let minDate = this.cotacaoSelecionada.confirmation_date;
        this.ngxLoader.startLoader('loader-principal');

        this.generalService.getDeliveryDateByWorkingDays(this.max_days_delivery).subscribe({
            next: (response: ApiResponseModel<{deliveryDate: any}>) => {
                let maxDate = new Date(response.result.deliveryDate);

                this.calendarMinDate = { year: minDate.getFullYear(), month: minDate.getMonth() + 1, day: minDate.getDate() };
                this.calendarMaxDate = { year: maxDate.getFullYear(), month: maxDate.getMonth() + 1, day: maxDate.getDate() };
                this.calendarMarkDisabled = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                console.log(error);
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    public get valor_total()
    {
        let quantidade = (isEmpty(this.peca.quantidade)) ? 0 : this.peca.quantidade;
        let desconto = (isEmpty(this.peca.desconto)) ? 0 : this.peca.desconto;
        let valor_unitario = (isEmpty(this.peca.valor_unitario)) ? 0 : this.peca.valor_unitario;

        return quantidade * (valor_unitario * (1 - (desconto / 100)));
    }
}
